import { api, createQueryHandler } from './base';
import { DepositBonus, UserDepositBonusWithBonusProgress, ApplyBonusToUserDto } from '@repo/common-types';

export const depositBonusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDepositBonuses: builder.query<DepositBonus[], void>({
      query: createQueryHandler('/v1/admin/deposit-bonus'),
      providesTags: ['DepositBonus'],
    }),
    getUserDepositBonuses: builder.query<UserDepositBonusWithBonusProgress[], string>({
      query: (userId) => ({
        url: `/v1/admin/deposit-bonus/users/${userId}`,
        method: 'GET',
      }),
      providesTags: (result, error, userId) => [{ type: 'UserDepositBonus', id: userId }, 'UserDepositBonus'],
    }),
    applyBonusToUser: builder.mutation<UserDepositBonusWithBonusProgress, ApplyBonusToUserDto>({
      query: (data) => ({
        url: `/v1/admin/deposit-bonus/users/${data.userId}/apply`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, data) => [{ type: 'UserDepositBonus', id: data.userId }, 'UserDepositBonus'],
    }),
  }),
});

export const { useGetDepositBonusesQuery, useGetUserDepositBonusesQuery, useApplyBonusToUserMutation } =
  depositBonusApi;
